export const useRowClickHandler = () => {
    const handleRowClick = ({ setSelectedRowData = undefined, toggleSelection = undefined, tableRow, }) => {
        if (setSelectedRowData)
            setSelectedRowData(tableRow.row);
        if (toggleSelection)
            toggleSelection();
    };
    return { handleRowClick };
};
//# sourceMappingURL=useRowClickHandler.js.map